var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"box-shadow",class:{
    'full-height': _vm.fullHeight,
    'no-border': _vm.noBorder,
    'no-elevation': _vm.noElevation,
  },style:(("\n    background-color: " + _vm.backgroundColor + ";\n    border-radius: " + _vm.borderRadius + "!important;\n  "))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }